var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStateDone = function SvgStateDone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8211 10.1996C21.2321 12.2168 20.9392 14.3139 19.9912 16.1412C19.0431 17.9686 17.4973 19.4157 15.6115 20.2412C13.7256 21.0668 11.6138 21.2208 9.62807 20.6778C7.64238 20.1347 5.90288 18.9273 4.69966 17.2569C3.49644 15.5865 2.90222 13.5542 3.01611 11.4987C3.13 9.44322 3.9451 7.48893 5.32549 5.9617C6.70589 4.43447 8.56813 3.42664 10.6017 3.10626C12.6352 2.78588 14.7171 3.17232 16.5002 4.20115M9.3002 11.0996L12.0002 13.7996L21.0002 4.79965",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStateDone);
export { ForwardRef as ReactComponent };